<template>
  <div>
    <section class="content-header">
      <h1>
        จัดการป้ายโฆษณา (Banner)
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>จัดการป้ายโฆษณา (Banner)
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-body">
                <div class="wrapper_typegroup">
                  <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="ป้ายโฆษณาบน CMS" name="CMS">
                      <el-image :src="banner_info.banner_img"></el-image>
                      <p>แก้ไขล่าสุดเมื่อ {{banner_info.updated_at}} โดย {{ banner_info.updated_by }}</p>
                      <el-button @click="handleEdit('CMS')">แก้ไข</el-button>
                    </el-tab-pane>
                    <el-tab-pane label="ป้ายโฆษณาบนเว็บไซต์" name="Website">
                      <el-image :src="website_banner_info.banner_img"></el-image>
                      <p>แก้ไขล่าสุดเมื่อ {{website_banner_info.updated_at}} โดย {{ website_banner_info.updated_by }}</p>
                      <el-button @click="handleEdit('Website')">แก้ไข</el-button>
                    </el-tab-pane>
                  </el-tabs>
                  <el-dialog :title="formdialog.title" :visible.sync="formdialog.visible">
                    <el-form :model="formdialog" label-position="top">
                      <el-form-item label="รูปภาพ">
                        <el-image v-if="preview_img" :src="preview_img"></el-image>
                        <el-image v-else :src="formdialog.banner_img"></el-image>
                        <el-upload
                            type="file"
                            class="upload-demo"
                            ref="file"
                            action="#"
                            :on-change="onFileChange"
                            :show-file-list="false"
                            :limit="1"
                            :auto-upload="false"
                            accept="image/jpeg,image/png"
                        >
                        <el-button
                          v-if="upload_btn"
                            slot="trigger"
                            size="small"
                        >อัปโหลดไฟล์รูปภาพ</el-button>
                        </el-upload>
                      </el-form-item>
                      <el-form-item label="วันเริ่มต้นแสดงผล" required>
                        <el-date-picker
                          v-model="formdialog.start_date"
                          type="date"
                          placeholer="วันเริ่มต้น"
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="วันสิ้นสุดแสดงผล">
                        <el-date-picker
                          v-model="formdialog.end_date"
                          type="date"
                          placeholer="วันสิ้นสุด"
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="การแสดงผล">
                        <el-switch
                          v-model="formdialog.active_status"
                          active-text="แสดง"
                          inactive-text="ไม่แสดง">
                        </el-switch>
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="handleClose()">ย้อนกลับ</el-button>
                      <el-button type="primary" @click="confirm()">ยืนยัน</el-button>
                    </span>
                  </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
        preview_img : '',
        file : null,
        action_pane : false,
        upload_btn : true,
        activeName: 'CMS',
        formdialog: {
          title : 'แก้ไขรูปภาพโฆษณา CMS',
          visible : false,
          start_date: null,
          end_date: null,
          active_status: true,
          banner_type: '',
          banner_img : ''
        }
    };
  },
  computed: {
    ...mapState({
      banner_info: store => store.Login_store.banner_info,
      website_banner_info: store => store.Login_store.website_banner_info
    })
  },
   mounted() {
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission))
    this.upload_btn = permission.Manage_banner.includes('edit')
    this.$store.dispatch('Login_store/get_banner')
  },
  methods: {
   ...mapActions({
      update_banner: "Login_store/update_banner"
    }),
    onFileChange(e){
        this.$refs.file.clearFiles()
        this.file = e.raw;
        this.preview_img = URL.createObjectURL(this.file);
    },
    confirm(){
      if(!this.formdialog.start_date){
        return this.$confirm("กรุณาระบุวันเริ่มต้นแสดงผล", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }
        let formdata = new FormData()
        formdata.append("typeFile", "banner")
        formdata.append("file", this.file)
        formdata.append("banner_type", this.formdialog.banner_type)
        formdata.append("start_date", this.formdialog.start_date)
        formdata.append("end_date", this.formdialog.end_date)
        formdata.append("active_status", (this.formdialog.active_status ? '1' : '0'))
        this.update_banner(formdata)
        this.formdialog.visible = false
    },
    handleClick(tab, event) {

    },
    handleEdit(type){
      this.formdialog.visible = true
      this.formdialog.banner_img = type == 'CMS' ? this.banner_info.banner_img : this.website_banner_info.banner_img
      this.formdialog.title = type == 'CMS' ? 'แก้ไขรูปภาพโฆษณา CMS' : 'แก้ไขรูปภาพโฆษณาเว็บไซต์'
      this.formdialog.banner_type = type
      this.formdialog.active_status = type == 'CMS' 
                                    ? this.banner_info.active_status == '1' ? true : false
                                    : this.website_banner_info.active_status == '1' ? true : false
      this.formdialog.start_date = type == 'CMS' ? this.banner_info.start_date : this.website_banner_info.start_date
      this.formdialog.end_date = type == 'CMS' ? this.banner_info.end_date : this.website_banner_info.end_date
    },
    handleClose(){
      this.$refs.file.clearFiles()
      this.preview_img = ''
      this.formdialog.visible = false
    }
  }
};
</script>
